var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTgIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_284)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6569 15.8983C10.6848 15.9677 10.7332 16.0269 10.7957 16.068C10.8582 16.1091 10.9317 16.1301 11.0065 16.1282C11.0813 16.1263 11.1537 16.1015 11.214 16.0573C11.2743 16.013 11.3196 15.9514 11.3439 15.8807L16.1091 1.95157C16.1325 1.88661 16.137 1.81631 16.122 1.7489C16.1069 1.68149 16.073 1.61976 16.0242 1.57092C15.9754 1.52208 15.9136 1.48816 15.8462 1.47313C15.7788 1.4581 15.7085 1.46258 15.6435 1.48604L1.71445 6.25126C1.6437 6.27552 1.58206 6.32084 1.53782 6.38115C1.49357 6.44145 1.46883 6.51384 1.46692 6.58861C1.465 6.66337 1.486 6.73694 1.52711 6.79943C1.56821 6.86191 1.62744 6.91033 1.69685 6.93818L7.51042 9.26948C7.6942 9.34306 7.86118 9.45309 8.00128 9.59295C8.14139 9.7328 8.25172 9.89958 8.32564 10.0832L10.6569 15.8983Z",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0212 1.57397L8.00098 9.59347",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_284"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5947,
    height: 17.5947,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgIcon);
export default __webpack_public_path__ + "static/media/tg_icon.927f2b1ac73371e732f55b4c7aa7f093.svg";
export { ForwardRef as ReactComponent };